let ddmmyyyy = function (dateObj) {
  var mm = dateObj.getMonth() + 1; // getMonth() is zero-based
  var dd = dateObj.getDate();

  return [
    (dd > 9 ? "" : "0") + dd,
    (mm > 9 ? "" : "0") + mm,
    dateObj.getFullYear(),
  ].join("-");
};

function RemarkCard({ companyName, date, remark }) {
  return (
    <div className="flex flex-row overflow-hidden text-lg leading-[1.5] justify-between h-[8rem] items-start mb-4 bg-white text-left text-[#585858] rounded-2xl outline-2 outline-gray-200">
      <div className="py-4 px-8">
        <p className="font-semibold">Company:</p>
        <p>{companyName}</p>
      </div>
      <div className="py-4 px-8">
        <p className="font-semibold">Date:</p>
        <p>{ddmmyyyy(new Date(date))}</p>
      </div>
      <div className="basis-[60%] bg-[#ffd5d5] h-full py-4 px-8">
        <p className="font-semibold">Remark:</p>
        <p className="line-clamp-2">{remark}</p>
      </div>
    </div>
  );
}

export default RemarkCard;
